import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    UserLocation,
    ClientHierarchy,
    SavedFilters,
    EmployeeType,
    IStaffPosition,
    ILocationItem,
    IEmployeeInfo,
    IUserEmployee,
    IHierarchyFilterParameters,
} from '../interfaces/user-location';
import { Router } from '@angular/router';
import { HierarchyFiltersCustomOptions } from '../components/main-filters/hierarchy-filter-options/hierarchy-flters-custom-options';

@Injectable({
    providedIn: 'root',
})
export class FiltersService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5'; // TODO Get version dynamically
    private _url = (this.serverUrl + '/api/v{version}/filters').replace('{version}', this.version);

    apiVersion: string;
    constructor(private http: HttpClient, private _router: Router) {}

    getUsersAllLocations(employeeType: EmployeeType): Observable<UserLocation[]> {
        const params = new HttpParams().set('employeeType', employeeType.toString());
        return this.http.get<UserLocation[]>(this._url + '/byuser', { params: params });
    }

    getLocationDetails(location: string): Observable<ILocationItem[]> {
        const params = new HttpParams().set('location', location);
        return this.http.get<ILocationItem[]>(this._url + '/byUserLocation', {
            params: params,
        });
    }

    getSubLocationDetails(location: string, subLocation: string): Observable<ILocationItem[]> {
        const params = new HttpParams().set('location', location).set('subLocation', subLocation);
        return this.http.get<ILocationItem[]>(this._url + '/byUserSubLocation', {
            params: params,
        });
    }

    getEmployeeDetails(
        locationSelected: any,
        isEmployeeTopLevel: boolean,
        employeeType?: EmployeeType
    ): Observable<IEmployeeInfo> {
        let hierarchyCacheInfo = new HierarchyFiltersCustomOptions();
        let url = this._router.url.split('?')[0];
        let hierarchyCachePageInfo = hierarchyCacheInfo.getHierarchyCachePageInfo(url);

        if (!employeeType) {
            employeeType = hierarchyCachePageInfo.employeeType;
        }

        let parameters: IHierarchyFilterParameters = {
            hFilterJSON: locationSelected,
            employeeType: employeeType,
            isUseActivityDate: hierarchyCachePageInfo.isUseActivityDate ? '1' : '0',
            isEmployeeTopLevel: isEmployeeTopLevel ? '1' : '0',
        };

        return this.http.post<IEmployeeInfo>(this._url + '/GetEmployee', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getEmployeeByPosition(
        locationSelected: string,
        staffingKey: string,
        filterType: string
    ): Observable<IUserEmployee[]> {
        let parameters = {
            hFilterJSON: locationSelected,
            staffingKey: staffingKey,
            filterType: filterType,
        };

        return this.http.post<IUserEmployee[]>(this._url + '/GetEmployeeByPosition', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    deleteSavedFilters(savedFilterKey: number): Observable<number> {
        const params = new HttpParams().set('savedFilterKey', savedFilterKey.toString());
        return this.http.get<number>(this._url + '/DeleteSavedFilters', {
            params: params,
        });
    }

    createHierarchy(hierarchyData: ClientHierarchy) {
        const params = new HttpParams().set('hierarchyData', JSON.stringify(hierarchyData));

        return this.http.get<number>(this._url + '/byCreateHierarchy', {
            params: params,
        });
    }

    saveSelectedFilters(
        saveFilterName: string,
        filterDataToSave: string,
        overrideExistingFilters: boolean
    ): Observable<number> {
        let parameters = {
            saveFilterName: saveFilterName,
            overrideExistingFilters: overrideExistingFilters ? '1' : '0',
            filterDataToSave: filterDataToSave,
        };

        return this.http.post<number>(this._url + '/SaveSelectedFilters', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getSavedFilters(): Observable<SavedFilters[]> {
        return this.http.get<SavedFilters[]>(this._url + '/GetSavedFilters');
    }

    getPosition(parameters: object = null): Observable<IStaffPosition[]> {
        if (parameters === null) {
            let hierarchyCacheInfo = new HierarchyFiltersCustomOptions();
            let url = this._router.url.split('?')[0];
            let hierarchyCachePageInfo = hierarchyCacheInfo.getHierarchyCachePageInfo(url);
            parameters = {
                static: '1',
                addExtraPositions: hierarchyCachePageInfo?.addExtraPositions ? '1' : '0',
            };
        }

        let params: HttpParams = new HttpParams().set('paramsString', JSON.stringify(parameters));
        return this.http.get<IStaffPosition[]>(this._url + '/GetPosition', { params: params });
    }
}
